import Vue from 'vue'


import XLabelDesigner from './components/XLabelDesigner.vue'
Vue.component(XLabelDesigner.name, XLabelDesigner)

